import { jsx as _jsx } from "react/jsx-runtime";
export const GenericPreview = ({ messages }) => {
    if (!messages) {
        return null;
    }
    return [
        _jsx("div", { className: 'flex flex-col gap-y-4 p-4', "data-study-product-version": 'r440', children: Object.values(messages).map((value) => (_jsx("div", { style: {
                    border: '1px solid #E5E7EB',
                    borderRadius: '0.25rem',
                    padding: '0.5rem',
                    color: 'rgba(17, 24, 39, 0.60)',
                    fontSize: '14px',
                    fontWeight: '500',
                }, children: value }, value))) }, 'generic-preview-root'),
    ];
};
//# sourceMappingURL=generic.previews.component.js.map